
import React, { useState, useEffect, useRef } from 'react';
import { BiX } from "react-icons/bi";
import './style.css'; // Reuse style or create new one

const MultiSearchDropdown = ({
    options = [],
    path = 'name',
    placeholder = "Seleccionar...",
    onSelected,
    selected = []
}) => {
    const [query, setQuery] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    const containerRef = useRef(null);

    // Filter options based on query and exclude already selected ones
    const filteredOptions = options.filter(option =>
        option[path].toLowerCase().includes(query.toLowerCase()) &&
        !selected.some(sel => sel.id === option.id)
    );

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (containerRef.current && !containerRef.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const handleSelect = (option) => {
        const newSelected = [...selected, option];
        onSelected(newSelected);
        setQuery(""); // Reset query after selection
        // Keep open for multiple selections? Maybe better to close or keep open implementation choice.
        // Let's keep it open for easier multi-select
    };

    const handleRemove = (id) => {
        const newSelected = selected.filter(item => item.id !== id);
        onSelected(newSelected);
    };

    return (
        <div className="multi-search-dropdown" ref={containerRef}>
            <div className="selected-items-container">
                {selected.map(item => (
                    <span key={item.id} className="selected-tag">
                        {item[path]}
                        <BiX
                            className="remove-tag-icon"
                            onClick={() => handleRemove(item.id)}
                        />
                    </span>
                ))}
                <input
                    type="text"
                    className="multi-search-input"
                    placeholder={selected.length === 0 ? placeholder : ""}
                    value={query}
                    onChange={(e) => {
                        setQuery(e.target.value);
                        setIsOpen(true);
                    }}
                    onFocus={() => setIsOpen(true)}
                />
            </div>

            {isOpen && (
                <ul className="dropdown-options-list">
                    {filteredOptions.length > 0 ? (
                        filteredOptions.map(option => (
                            <li
                                key={option.id}
                                onClick={() => handleSelect(option)}
                                className="dropdown-option-item"
                            >
                                {option[path]}
                            </li>
                        ))
                    ) : (
                        <li className="dropdown-no-results">No hay resultados</li>
                    )}
                </ul>
            )}
        </div>
    );
};

export default MultiSearchDropdown;
